import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { FormattedMessage } from "react-intl";

import { BannerInline } from "../../../../../../components/bannerInline/BannerInline";
import { isBlockedLimitReached } from "../../../../../../store/devices/logicalDevices";
import { isBlockedLimitInfoVisible } from "../../../../../../store/banners/banners.selectors";
import { hideBlockedLimitWarning } from "../../../../../../store/banners/banners.actions";

export const BlockedDeviceLimitReached = () => {
  const isLimitReached = useSelector(isBlockedLimitReached);
  const isPanelVisible = useSelector(isBlockedLimitInfoVisible);
  const dispatch = useDispatch();

  if (!isPanelVisible || !isLimitReached) return null;

  return (
    <BannerInline
      onClick={() => dispatch(hideBlockedLimitWarning())}
      message={<FormattedMessage id={"blocked_devices_limit_reached"} />}
    />
  );
};
